export var buildDatasetQuery = function buildDatasetQuery(selectedValues, masks, lang, filterLogic, filterKey) {
  var _query;
  if (masks === void 0) {
    masks = [];
  }
  if (lang === void 0) {
    lang = 'fr';
  }
  var query = [];
  Object.keys(selectedValues).forEach(function (key) {
    if (filterLogic !== 'or' || key !== filterKey) {
      if (selectedValues[key].length > 1) {
        var filterQuery = [filterLogic];
        selectedValues[key].map(function (value) {
          filterQuery.push(['match', key, value]);
        });
        query.push(filterQuery);
      } else {
        query.push(['match', key, selectedValues[key][0]]);
      }
    }
  });
  masks.map(function (mask) {
    return query.push(['match', "q__" + lang, mask]);
  });
  if (((_query = query) === null || _query === void 0 ? void 0 : _query.length) > 1) {
    query.unshift('and');
  } else {
    query = query.pop();
  }
  // console.log(query)
  return query;
};
export var transformProperties = function transformProperties(properties, language, defaultLanguage, fields) {
  var localizedProperties = {};
  fields.forEach(function (f) {
    if (properties[f + "::" + language]) {
      localizedProperties[f] = properties[f + "::" + language];
    } else if (properties[f + "::" + defaultLanguage]) {
      localizedProperties[f] = properties[f + "::" + defaultLanguage];
    } else {
      localizedProperties[f] = properties[f];
    }
  });
  localizedProperties.mediasets = properties.mediasets;
  return localizedProperties;
};